import { HeliosDataProvider } from 'providers/admin/dataProvider';
import { useDataProvider } from 'react-admin';
import { useMutation } from 'react-query';
import { ActionMutationReturn } from 'types/common.types';
import { UploadProfilePictureBody } from 'types/customMethods.types';

export const useUploadProfilePicture = (): ActionMutationReturn<
  void,
  unknown,
  { customerId: string; data: UploadProfilePictureBody },
  unknown
> => {
  const dataProvider = useDataProvider<HeliosDataProvider>();

  return useMutation(
    ['uploadProfilePicture', dataProvider],
    async (params: { customerId: string; data: UploadProfilePictureBody }) => {
      await dataProvider.uploadProfilePicture(params.customerId, params.data);
    }
  );
};
